<div class="container">
  <div class="wrapper">
    <!-- <alert role="alert" route="{{!slotAvailable ? 'calendar' : ''}}"></alert> -->
    <h1 class="pageTitle">{{ pageTitle }}</h1>
    <app-notifications [notification]="'summary_page_notification_banner_child'"></app-notifications>
    <hr />

    <!-- Confirmation box -->
    <!-- <div class="row mt-4 mb-4 confirm-box" *ngIf="slotAvailable">
      <div class="col">
        {{ 'CONFIRMATION.REVIEW_CONFIRMATION' | translate }}
      </div>
    </div> -->

    <div class="bb-panel">
      <div class="row panel-row-heading">
        <h2 class="section-heading col-sm-12">
          {{ 'SUMMARY.LOCATION' | translate }}
        </h2>
      </div>

      <div class="row panel-row">
        <div class="col-sm-6">{{ 'COMMON.SITE' | translate }}</div>
        <div class="col-sm-6">{{ selectedLocation?.name }}</div>
      </div>
      <div class="row panel-row">
        <div class="col-sm-6">Address</div>
        <div class="col-sm-6">
          <span>{{ address?.address1 }}, </span>
          <span *ngIf="address?.address2">{{ address?.address2 }}, </span>
          <span *ngIf="address?.address3">{{ address?.address3 }}, </span>
          <span *ngIf="address?.address4">{{ address?.address4 }}, </span>
          <span *ngIf="address?.address5">{{ address?.address5 }}, </span>
          <!-- <span *ngIf="address?.country">{{address?.country}}, </span> -->
          {{ address?.postcode }}
        </div>
      </div>
      <!-- <div class="row panel-row">
                <div class="col-sm-6">Phone Number</div>
                <div class="col-sm-6"><span *ngIf="address?.homephone">0</span>{{address?.homephone}}</div>
            </div> -->

      <div class="row panel-row-heading">
        <h2 class="section-heading col-sm-12">Date and time</h2>
      </div>

      <div class="row panel-row">
        <div class="col-sm-6">Date</div>
        <div class="col-sm-6">
          {{ selectedSlot?.datetime | date : 'EEEE d MMMM yyyy' }}
        </div>
      </div>
      <div class="row panel-row">
        <div class="col-sm-6">{{ 'COMMON.TIME' | translate }}</div>
        <div class="col-sm-6">
          {{ selectedSlot?.datetime | date : 'HH:mm' }} -
          {{ endSlot | date : 'HH:mm' }}
        </div>
      </div>

      <div class="row panel-row-heading">
        <h2 class="section-heading col-sm-12">Your details</h2>
      </div>

      <div class="row panel-row">
        <div class="col-sm-6">Name</div>
        <div class="col-sm-6">
          {{ client?.first_name }} {{ client?.last_name }}
        </div>
      </div>
      <div class="row panel-row">
        <div class="col-sm-6">Email address</div>
        <div class="col-sm-6">{{ client?.email_address }}</div>
      </div>
      <div class="row panel-row" *ngIf="client?.mobile_number">
        <div class="col-sm-6">
          {{ 'ACCOUNT.MY_ACCOUNT.CONTACT_NUMBER_LBL' | translate }}
        </div>
        <div class="col-sm-6">0{{ client?.mobile_number }}</div>
      </div>
      <div class="row panel-row" *ngIf="registration">
        <div class="col-sm-6">Vehicle registration</div>
        <div class="col-sm-6">{{ registration }}</div>
      </div>

      <div *ngIf="total > 1">
        <div class="row panel-row-heading">
          <h2 class="section-heading col-sm-12" tabindex="0">Your purchases</h2>
        </div>

        <div class="row panel-row">
          <div class="col-sm-6">{{ selectedService?.name }}</div>
          <div class="col-sm-6">
            {{ selectedService?.price / 100 | currency : 'GBP' : true }}
          </div>
        </div>

        <div *ngFor="let item of bookingSummaryData">
          <div class="row panel-row" *ngIf="item.detail_type === 'check-price'">
            <div class="col-sm-6">{{ item.name }}</div>
            <div class="col-sm-6">
              {{ item.price / 100 | currency : 'GBP' : true }}
            </div>
          </div>
        </div>

        <div class="row panel-row total-row">
          <div class="col-sm-6"><strong>Total</strong></div>
          <div class="col-sm-6">
            {{ total / 100 | currency : 'GBP' : true }}
          </div>
        </div>
      </div>

      <form [formGroup]="customerDetailsForm" autocomplete="off" class="col-sm-12">
        <div class="row panel-row-heading">
          <h2 class="section-heading col-sm-12" tabindex="0">{{ 'COMMON.DATA_POLICY' | translate }}</h2>
        </div>
        <div class="row panel-row-no-bottom">

          <div class="bb-flex row row-blocks" id="tcs">
            <div class="bb-flex col col-blocks wide">
              <label for="PNCheck-input" [innerHTML]="dataPolicy"></label>
            </div>
          </div>
          <div class="bb-flex row row-blocks" id="tcs">
            <div class="bb-flex col col-blocks bottom">
              <mat-checkbox id="PNCheck" class="checkbox mr-2 ml-2 col-sm-12 privacy-policy" validationForm="PNCheck"
                formControlName="privacy_notice">
                <label for="PNCheck" class="by-tick-side"
                  style="font-size: 16px !important; font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif !important;">Please
                  tick to confirm acceptance</label>
              </mat-checkbox>
            </div>
          </div>
          <div *ngIf="submitted && form.privacy_notice.errors" class="invalid-feedback">
            <div *ngIf="form.privacy_notice.errors.required" role="alert" tabindex="0">
              Please ensure that you have read and understood our data policy
              and terms of use before proceeding with your booking.
            </div>
          </div>
        </div>
        <div class="row panel-row-no-bottom">

          <div class="bb-flex row row-blocks" id="tcs">
            <div class="bb-flex col col-blocks wide">
              <label for="TCCheck-input" [innerHTML]="dataPolicyTwo"></label>
            </div>
          </div>
          <div class="bb-flex row row-blocks" id="tcs">
            <div class="bb-flex col col-blocks bottom">
              <mat-checkbox id="TCCheck" class="checkbox mr-2 ml-2 col-sm-12 privacy-policy" validationForm="TCCheck"
                formControlName="terms_and_conditions">
                <label for="TCCheck" class="by-tick-side"
                  style="font-size: 16px !important; font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif !important;">Please
                  tick to confirm acceptance</label>
              </mat-checkbox>
            </div>
          </div>
          <div *ngIf="submitted && form.terms_and_conditions.errors" class="invalid-feedback">
            <div *ngIf="form.terms_and_conditions.errors.required" role="alert" tabindex="0">
              Please ensure that you have read and understood the terms and
              conditions and terms of use before proceeding with your booking.
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="mt-2" *ngIf="showMap">
      <app-leaflet-map [num]="1"></app-leaflet-map>
    </div>



    <div class="row mt-4">
      <div class="col-6">
        <button type="button" class="btn btn-primary" (click)="routerGoBack()" title="Back"
          aria-label="Back to booking details">
          <span><fa-icon [icon]="faChevronLeft"></fa-icon><span>{{ 'COMMON.BACK' | translate }}</span></span>
        </button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary float-right" type="button" (click)="startCheckout()" title="Confirm"
          aria-label="Confirm booking">
          <span>
            <span>{{ 'COMMON.CONFIRM' | translate }}</span>
            <span style="padding-left: 25px">
              <fa-icon [icon]="faChevronRight"></fa-icon>
            </span>
          </span>
        </button>
      </div>
    </div>
  </div>
  <br />
  <br />
</div>